import { TaxDataUtil } from '@ddt-web/data-service';
import { AssetResolveResponse } from '@ddt-web/pas';

export class TaxResponseEnricher {
	public static enrichSecurityTax(positionDataFromApiCall: any): AssetResolveResponse { // TO BE UPDATED
		positionDataFromApiCall?.assets?.forEach(asset => {
			this.validateAndUpdateTaxData(asset);
		});
		return positionDataFromApiCall;
	}

	private static validateAndUpdateTaxData(security: any): void {

		if (security.customClientProperties?.taxEstimatesSellDate && security.assetAnalytics) {
			const daysLeftSell = TaxDataUtil.calculateDaysLeftSell(security.customClientProperties.taxEstimatesSellDate);
			let status = security.customClientProperties.taxStatusFlag;
			const tagStatus = TaxDataUtil.hasNewEstimates(daysLeftSell, security.customClientProperties.taxEstimatesEntryDate);
			const taxWorstOffenderFlag = security?.customClientProperties?.taxWorstOffenderFlag;

			// this check is to account for the case where a fund has status 'Pending' and the sell by date has been met or exceeded but the data has yet to be updated
			// if the data had been updated, the taxStatusFlag would be set to 'Distributed'
			// in this case, we manually set the flag so that the front end will display the correct status
			// tax data is updated daily, so there is only a small window on the sell by date where this condition is met
			// we need to account for 'status !== 'Not Distributing' as we have seen erroneous data which provides a sell by date for funds where the taxStatusFlag is 'Not Distributing'
			// these funds should never have the status changed to 'Distributed'
			if (status !== 'Not Distributing' && daysLeftSell <= 0) {
				status = 'Distributed'; // cannot use const because of circular dependencies
			}
			security['assetAnalytics']['daysLeftSell'] = daysLeftSell;
			security['customClientProperties']['taxStatusFlag'] = status;
			security['customClientProperties']['hasNewBadge'] = String(tagStatus);
			security['customClientProperties']['taxWorstOffenderFlag'] = taxWorstOffenderFlag === 'true' && status === 'Active' ? 'true' : 'false';
		}
	}
}
